import Advertise from './advertise';
import Contacts from './contacts';
import Errors from './errors';
import Layout from './layout';
import Notification from './notification';
import Transfer from './transfer';
import Transfers from './transfers';
import TransfersReceived from './transfers-received';
import Pending from './pending';
import Route from './route';
import Session from './session';
import User from './user';
import Account from './account';
import UI from './ui';
import Invoices from './invoices';
import ApiGrants from './apigrants';
import BillingDetails from './billingdetails';
import Consent from './consent';

export default {
  Advertise,
  Contacts,
  Layout,
  Notification,
  Transfer,
  Session,
  Route,
  Transfers,
  TransfersReceived,
  User,
  Account,
  Pending,
  Errors,
  UI,
  Invoices,
  ApiGrants,
  BillingDetails,
  Consent,
};
